export default [
  {
    name: 'Trust Overview',
    icon: 'ti-home',
    path: '/management/trustoverview',
    PFTC: false
  },
  {
    name: 'View Account',
    icon: 'ti-eye',
    path: '/management/accountview'
  },
  {
    name: 'Recent Distributions',
    icon: 'ti-agenda',
    path: '/management/recentdistributions',
    PFTC: false
  },
  {
    name: 'Recent Contributions',
    icon: 'ti-agenda',
    path: '/management/recentcontributions',
    PFTC: false
  },
  {
    name: 'Forms and Pamphlets',
    icon: 'ti-clipboard',
    path: '/dashboard/documents',
    PFTC: false
  },
  {
    name: 'Manage Users',
    icon: 'fa fa-users',
    path: '/management/managers',
    role: 'Admin'
  },
  {
    name: 'Reports',
    icon: 'ti-envelope',
    // path: '/management/reports',
    role: 'Admin',
    PFTCOnly: true,
    report: true,
    children: [
      {
        name: 'Assigned Accounts',
        icon: 'ti-envelope',
        path: '/management/reports/assigned-accounts'
      },
      {
        name: 'Electronic Statements',
        icon: 'ti-envelope',
        path: '/management/reports/electronic-statements'
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/managementSidebarLinks.js